<template>
    <div class="content-wrapper flex flex-direction flex-sub padding-sm">
        <div class="bg-white padding-sm flex-sub">
            <div class="search-container flex align-center justify-between">
                <div class="flex align-center ">
                    <el-input v-model="xingming" placeholder="请输入姓名"/>
                    <el-select
                        v-model="sex"
                        class="margin-left-xs"
                        placeholder="请选择性别">
                        <el-option
                            v-for="(item) in sexs"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select
                        v-model="education"
                        class="margin-left-xs"
                        placeholder="请选择文化程度">
                        <el-option
                            v-for="(item) in educations"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-button
                        class="btn mid margin-left-xs"
                        type="primary"
                        @click="search"><i class="el-icon-search"></i>搜索
                    </el-button>
                </div>
                <div class="flex align-center">
                    <el-button
                        class="margin-left btn mid"
                        type="primary"
                        @click="toPage(`/manager/organization/cadres_tribune/add/0`)" v-permission="'organization'">添加
                    </el-button>
                    <el-button
                        class="margin-left btn mid"
                        type="primary"
                        @click="exportData">导出
                    </el-button>
                    <el-button
                        class="margin-left btn mid"
                        type="primary"
                        @click="toPage(`/digitize`)">预览
                    </el-button>
                </div>
            </div>
            <div class="page-list flex flex-direction margin-top-sm">
                <el-table
                    v-loading="loading"
                    :data="lists"
                    :row-class-name="tableRowClassName"
                    border
                    header-row-class-name="table-header"
                    style="width: 100%">
                    <el-table-column label="序号" prop="index">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ (scope.$index + 1) + (page - 1) * limit }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="姓名" prop="name">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="性别" prop="sex">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.sex | sex }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="民族" prop="nation">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.nation | nation }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="出身日期" prop="birthday">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.birthday }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="籍贯" prop="native_place">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.native_place }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="文化程度" prop="education">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.education | education }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="党员类型" prop="user_type_name">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.user_type_name }}
                            </div>
                        </template>
                    </el-table-column>
<!--                    <el-table-column label="职称" prop="rank" width="160">-->
<!--                        <template slot-scope="scope">-->
<!--                            <div class="table-item">-->
<!--                                {{ scope.row.rank }}-->
<!--                            </div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column label="职务" prop="duty">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.duty }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" prop="end_time">
                        <template slot-scope="scope">
                            <div class="table-item text-sm">
                                <el-button type="text" @click="toPage(`/manager/organization/cadres_tribune/show/${scope.row.id}`)">
                                    查看
                                </el-button>
                                <el-button type="text" @click="toPage(`/manager/organization/cadres_tribune/add/${scope.row.id}`)"  v-permission="'organization'">
                                    编辑
                                </el-button>
                                <el-button type="text" @click="delItem(scope.row)"  v-permission="'organization'">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    :current-page.sync="page"
                    :page-size="limit"
                    :total="total"
                    background
                    class="page-all margin-top self-end"
                    layout="prev, pager, next,total"
                    @current-change="getList">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {confirm, downloadFile, TOAST, toast, zhDate} from "@/utils/utils";
import {
    getCadresTribuneList, delMember, exportCadresTribune
} from "@/api/index";
import {education_classify, nation_classify, sex_classify} from "@/utils/const";

export default {
    name: "cadres_tribune-list",
    components: {},
    data() {
        return {
            type: 2,
            xingming: '',
            sex:'',
            sexs:sex_classify,
            education:'',
            educations:education_classify,
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            loading: false,
        };
    },
    props: {},
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.init()
    },
    activated() {
        this.init()
    },
    methods: {
        init(){
            this.$emit('setIndex', [0,0])
            this.getList()
        },
        tableRowClassName({rowIndex}) {
            if (rowIndex % 2 === 0) {
                return 'white'
            } else {
                return 'redlight'
            }
        },
        async getList() {
            this.loading = true
            let _data = await getCadresTribuneList(this.type,this.xingming,this.sex,this.education, this.page, this.limit)
            this.lists = _data.data.data
            this.total = _data.data.total
            this.loading = false
        },
        search() {
            this.page = 1
            this.getList()
        },
        async exportData() {
           let _data = await exportCadresTribune(this.type,this.xingming,this.sex,this.education)
            if (_data.status === 200) {
                downloadFile(_data.data,'班子介绍.xlsx')
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        toPage(path) {
            this.$router.push(path)
        },
        delItem(item) {
            confirm(`删除`, `你确定删除<b>${item.name}</b>吗？`, () => {
                this.submitDel(item.id)
            }, '确认', true)
        },
        async submitDel(id) {
            let _data = await delMember(id)
            if (_data.status === 200) {
                toast('删除成功', TOAST.success)
                this.getList()
            } else {
                toast(_data.msg, TOAST.error)
            }
        }
    },
    filters: {
        zhDate(val) {
            return zhDate(val, 2)
        },
        sex(val) {
            return sex_classify.find(f=>{ return f.value === Number(val)})?.label || '--'
        },
        nation(val) {
            return nation_classify.find(f=>{ return f.value === Number(val)})?.label || '--'
        },
        education(val) {
            return education_classify.find(f=>{ return f.value === Number(val)})?.label || '--'
        }
    },
}
</script>

<style lang="scss" scoped>
.content-wrapper {

    .search-item {
        margin-bottom: 20px;
    }

    .search-tip {
        width: 120px;
        text-align: right;
    }

}
</style>